window.Promise = window.Promise || require('es6-promise');
import { render } from 'react-dom';
import React from 'react';
import dashboardStore from './stores/DashboardStore';
import { Provider } from 'mobx-react';
import '@ali/aps/dist/css/aps.css';
//如果需要动态根据路由打包js，请用这种方式——注意：不要为了偷懒把这个方法简化，变成传路径，经验告诉你，不生效！！！！
// const DashBoard = (location, callback) => {
//   require.ensure([], require => {
//     callback(null, require('./containers/DashBoard'));
//   }, 'dashboard') ; 
// };
//如果不需要动态加载用下面的，但注意route得相应改成component={}
import DashBoard from './containers/DashBoard';
window.tms = {
  'moduleinfo': {
    'id':1181572,
    'firstCartExplain': '此处为满减前价格，具体优惠金额以加入购物车结算时为准',
    'mainTitle': '购买产品种类越多，越享更低折扣，新年套餐5种产品，低至8折',
    'fristFloor': '交易类网站场景',
    'firstTips': '【我的专享活动】联系您的专属客户经理领取【优惠码】，还可享受多种云产品满减，立即前往',
    'firstJumpTips': '冬日满减分会场>>',
    'firstJumpUrl': 'https://promotion.aliyun.com/ntms/act/dec-sales.html',
    'firstTitle': '解决业务痛点',
    'h5FirstCombo':'',
    'h5FirstProduct':'5',
    'h5FirstDiscount':'8',
    'firstRule': {
      'one': {
        'leftPrice': '0',
        'rightText': '再多选1种，可享受95折，最高可满减2500元'
      },
      'two': {
        'leftPrice': '2500',
        'rightText': '再多选1种，可享受9折，最高可满减5000元'
      },
      'three': {
        'leftPrice': '5000',
        'rightText': '再多选1种，可享受8.5折，最高可满减7500元'
      },
      'four': {
        'leftPrice': '7500',
        'rightText': '再多选1种，可享受8折，最高可满减10000元'
      },
      'five': {
        'leftPrice': '10000',
        'rightText': '您已享受最高档优惠，立即加入购物车结算吧'
      }
    }
  },
  'firstDescListLeft': [
    { 'descLeft': '网站动态交互多，需优化访问体验' },
    { 'descLeft': '活动时段并发量高，应用服务器和数据库负载压力大' },
    { 'descLeft': '交易订单量突增，数据库读写并发量大' }
  ],
  'firstDescListRight': [
    { 'descRight': '交易支付场景验证码，短信使用量大，稳定性要求高' },
    { 'descRight': '需要满足低时延、稳定的用户营销触达' }
  ],
  'firstDiscountsExplainList': [
    { 'discount': '页面勾选多款产品，加入购物车，结算时即享满减优惠' },
    { 'discount': '购买套餐中2-5种产品，订单金额每满2000，可减100-400，最高满减10000元' },
    { 'discount': '四档满减，同一用户最多可享受4档，每档1次' }
  ],

};  
let store = {
  dashboardStore
};
render(
  <Provider {...store}>
    <DashBoard />
  </Provider>,
  document.getElementById('stage')
); 



// WEBPACK FOOTER //
// ./src/scripts/index.js